import { Option } from '../../components/dumb/atomics/DropdownInput';

function mapToOption(list: any | undefined): Option[] | [] {
  if (list?.length === 0 || list === undefined) {
    return [];
  }
  return list.map((item: any) => ({ value: item.id, label: item.name }));
}
export default mapToOption;
